<template>
  <common-dialog ref="dialog" width="600px" title="更新面单" id-key="id" :data="data" @edit-opened="onEditOpened"
    :form-rules="rules" :save-func="saveDataFunc" reset-on-close @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="寄件人" prop="senderAddress.fullName">
        <el-input v-model="data.senderAddress.fullName" placeholder="请输入寄件人"></el-input>
      </el-form-item>
      <el-form-item label="省市区" prop="address">
        <address-select style="width: 100%;" v-model="data.address" :placeholder="'请选择城市'" @change="onAddressSelect">
        </address-select>
      </el-form-item>
      <el-form-item label="详细地址" prop="senderAddress.detailAddress">
        <el-input v-model="data.senderAddress.detailAddress" placeholder="请输入详细地址"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="senderAddress.mobilePhone">
        <el-input v-model="data.senderAddress.mobilePhone" placeholder="请输入手机号码"></el-input>
      </el-form-item>
    </template>
    <template slot="footer">
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';
import pddPrint from "@/components/common/pddPrint"

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    pddPrint
  },
  data() {
    return {
      api: require('@/api/pdd/malladdresses').default,
      logisticsApi: require('@/api/pdd/logistics').default,
      data: {
        id: 0,
        wpCode: "", //快递公司Code
        address: "",
        shopId: 0, //店铺id
        shopName: "大龙猫杂货店", //店铺名称
        senderAddress: {
          country: "",
          province: "",
          city: "",
          district: "",
          street: "",
          detailAddress: "",
          postalCode: "",
          fullName: "",
          mobilePhone: "",
          dataMasking: false, //数据脱敏
        },
      },
      rules: {
        wpCode: [{ required: true, message: '请选择快递公司' }],
        'senderAddress.fullName': [{ required: true, message: '寄件人不能为空' }],
        'senderAddress.mobilePhone': [{ required: true, message: '手机号码不能为空' }],
        address: [{ required: true, message: '请选择发货地址' }],
        'senderAddress.detailAddress': [{ required: true, message: '请选择发货地址' }],
      },
      companiesList: [],
      senderAddresses: [],
    };
  },
  mounted() { },
  methods: {
    onEditOpened() {

    },
    onAddressSelect(e) {
      // this.data.address = e.map(x => x.label).join("/");
      console.log("111", e);
      console.log("222", this.data.address);
      // console.log("333", this.data.address);
    },
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null })
        // this.api.postSender(this.data).then(res => {
        //   if (res) {
        //     resolve({ Code: 1, Msg: res.errorMessage })
        //   } else {
        //     resolve({ Code: 0, Msg: null })
        //   }
        // })
      })
    },
  },
};
</script>
